import { ProjectData } from '../../../lib/propertyTypes';

// Make sure to exclude current project from the list
export const filterNearbyProjects = (
  projects: ProjectData[],
  currentProjectPropertyId: number,
): ProjectData[] => {
  return projects.filter(
    (project) => project.property_id !== currentProjectPropertyId,
  );
};
